import customColorAutomation from './custom-color-automation';
import userFontsLoader from './user-fonts-loader';

export default {
  customColorAutomation,
  userFontsLoader,
};
